import { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { useLocalStorage } from '@shared/utils';
import { useAuth } from '@app/AuthHook';
import { Trans, useTranslation } from 'react-i18next';
import { userServiceGiveConsent } from '@/api';

export const CookieConsentBar = () => {
    const [isVisible, setIsVisible] = useState(false);

    const { t, i18n } = useTranslation('main');
    const isRus = i18n.language === 'ru';

    const { user, setUser } = useAuth();
    const isUserAcceptCookie = !!user?.ConsentDate;
    const [isCookieAccepted, setCookieAccepted] = useLocalStorage('cookie_accepted', false);

    const handleCookieAccept = () => {
        if (user)
            userServiceGiveConsent().then((res) => {
                setUser && setUser({ ...user, ConsentDate: res?.data?.consentDate || 'true' });
            });
        setIsVisible(false);
        setCookieAccepted(true);
    };

    useEffect(() => {
        if (!isRus || isUserAcceptCookie) {
            setIsVisible(false);
            return;
        }
        if (isCookieAccepted && user && !isUserAcceptCookie) {
            userServiceGiveConsent().then((res) => {
                setUser && setUser({ ...user, ConsentDate: res?.data?.consentDate || 'true' });
            });
            return;
        }
        if (!isCookieAccepted) {
            setIsVisible(true);
        }
    }, [user, setUser, isCookieAccepted, isUserAcceptCookie, isRus]);

    if (!isVisible) return null;

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <span className={styles.text}>
                    <Trans
                        i18nKey="main:CookieConsentText"
                        components={{
                            policy: (
                                <a
                                    href="/api/v1/docs/SputnikPersonalConsent.pdf"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    className={styles.link}
                                />
                            ),
                            cookies: (
                                <a
                                    href="/api/v1/docs/SputnikCookiesConsent.pdf"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    className={styles.link}
                                />
                            ),
                        }}
                    />
                </span>
                <button className={styles.button} onClick={handleCookieAccept}>
                    {t('Accept')}
                </button>
            </div>
        </div>
    );
};
